"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FlagFind = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17.5,11 C19.9852814,11 22,13.0147186 22,15.5 C22,16.5624069 21.6318328,17.5388238 21.0161235,18.3086256 L22.8535534,20.1464466 C23.0488155,20.3417088 23.0488155,20.6582912 22.8535534,20.8535534 C22.679987,21.0271197 22.4105626,21.0464049 22.2156945,20.9114088 L22.1464466,20.8535534 L20.3086256,19.0161235 C19.5388238,19.6318328 18.5624069,20 17.5,20 C15.0147186,20 13,17.9852814 13,15.5 C13,13.0147186 15.0147186,11 17.5,11 Z M17.5,5 C17.5776225,5 17.6541791,5.01807255 17.7236068,5.0527864 C17.970596,5.17628103 18.0707082,5.47661755 17.9472136,5.7236068 L16.059017,9.5 L16.4150033,10.2115733 C16.0878578,10.3009458 15.7718561,10.4173107 15.4695401,10.5581261 L14.940983,9.5 L16.690983,6 L7,6 L7,13 L12.8032504,12.999037 C12.6200271,13.3156398 12.4649058,13.6505384 12.3412977,14.0003218 L7,14 L7,20 L6,20 L6,5 L17.5,5 Z M17.5,12 C15.5670034,12 14,13.5670034 14,15.5 C14,17.4329966 15.5670034,19 17.5,19 C19.4329966,19 21,17.4329966 21,15.5 C21,13.5670034 19.4329966,12 17.5,12 Z" })));
};
FlagFind.displayName = 'FlagFind';
exports.default = FlagFind;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FlagFind.js.map